
import { check } from '../../../../assets';
import { useAppContext } from '../../../../contexts';
import s from './ordersProgressBar.module.css';
import { useOrdersProgressBar } from './useOrdersProgressBar';

const OrdersProgressBar = (props) => {
    // Destructured props
    const {orderStatus} = props;

    const {stepInfos} = useOrdersProgressBar({orderStatus});

    const {highContrast} = useAppContext();

    return (
        <div className={s.progressContainer}>
            <div className={s.progressSteps}>
                <div className={`
                    ${s.progressStepOneContainer} 
                    ${stepInfos['first'] === 3 
                        ? `${highContrast ? "highGenericWrapper" : "bg-sabin-red-default"}`
                        : 'bg-white '
                    }
                `}>
                    <div className={`
                        rounded-full bg-white 
                        ${stepInfos['first'] === 2 
                            ? `${s.progressStepOneActive} ${highContrast ? "blackBorder" : ""}` 
                            : 'w-[25px]' 
                        }
                    `}>
                        {stepInfos['first'] === 3 
                        ? <img className={`w-full select-none ${highContrast ? "brightness-0" : ""}`} src={check} alt="check image" /> 
                        : <span className={"select-none left-[6px]"}>1</span>}
                    </div>
                </div>
                <div className={`
                    ${s.progressStepTwoContainer} 
                    ${stepInfos['second'] === 3 
                        ? `${highContrast ? "highGenericWrapper" : "bg-sabin-red-default"}`
                        : 'bg-white '
                    }
                `}>
                    <div className={`
                        rounded-full bg-white w-[25px] 
                        ${stepInfos['second'] === 2 ? `${s.progressStepTwoActive} ${highContrast ? "blackBorder" : ""}` : ''} 
                        ${stepInfos['second'] === 1 ? s.progressStepInactive : ''}
                    `}>
                        {stepInfos['second'] === 3 
                        ? <img className={`w-full select-none ${highContrast ? "brightness-0" : ""}`} src={check} alt="check image" />
                        : <span className={`select-none ${stepInfos['first'] ? 'text-[#666]' : ''}`}>2</span>}
                    </div>
                </div>
                <div className={`
                    ${s.progressStepThreeContainer} 
                    ${stepInfos['third'] === 3 
                        ? `rounded-r-full ${highContrast ? "highGenericWrapper" : "bg-sabin-red-default"}`
                        : 'bg-white '
                    }
                `}>
                    <div className={`${s.progressStepThree} ${highContrast ? "blackBorder" : ""}`}>
                        {stepInfos['third'] === 3 
                        ? <img className={`w-full select-none ${highContrast ? "brightness-0" : ""}`} src={check} alt="check image" />
                        : <span className={`select-none ${stepInfos['first'] || stepInfos['second'] ? 'text-[#666]' : ''}`}>3</span>}
                    </div>
                </div>
            </div>
            <div className={`${s.progressLabels} ${highContrast ? "highLabelFirst" : ""}`}>
                <div>PEDIDO SOLICITADO</div>
                <div>
                    {['processing_cancel', 'canceled'].includes(orderStatus) 
                    ? 'PROCESSANDO CANCELAMENTO' 
                    : 'APROVAÇÃO DO PAGAMENTO'}
                </div>
                <div>PEDIDO LIBERADO</div>
            </div>
        </div>
    )
}

export default OrdersProgressBar;